<template>
  <div id="header">
    <RouterLink to="/"><img src="@/assets/logo.svg" /></RouterLink>
  </div>
</template>

<style lang="sass">
.container {
  width: 100%;
  max-width: 100% !important;
  box-sizing: border-box;
  margin-inline: auto;
  padding-right: 19.8vw;
  padding-left: 19.8vw;
}
@media (max-width: 1800px) {
  .container {
    padding-right: 14vw;
    padding-left: 14vw;
  }
}
@media (max-width: 1440px) {
  .container {
    padding-right: 10vw;
    padding-left: 10vw;
  }
}
@media (max-width: 1340px) {
  .container {
    padding-right: 5%;
    padding-left: 5%;
  }
}
#header {
  text-align: center;
  padding: 27px 5% 17px 5%;
  height: 94px;
  img {
    width: 140px;
    margin-inline: auto;
  }
}
</style>
